import { Box } from '@mui/material';
import Paper from 'components/paper';
import React, { useState } from 'react';
import StepFour from 'views/playground/features/bluviu-nutrition-r2/components/step-four';
import StepOne from 'views/playground/features/bluviu-nutrition-r2/components/step-one';
import StepThree from 'views/playground/features/bluviu-nutrition-r2/components/step-three';
import StepTwo from 'views/playground/features/bluviu-nutrition-r2/components/step-two';
import StepsSideBar from 'views/playground/features/bluviu-nutrition-r2/components/steps-sidebar';
import { ScenarioPlanProvider } from 'views/playground/features/bluviu-nutrition-r2/context/scenario-plan-context';
import { StepProps } from 'views/playground/features/bluviu-nutrition-r2/types/step-props.type';

const RenderStep: React.FC<StepProps> = ({ onClick, activeStep }) => {
  switch (activeStep) {
    case 0:
      return <StepOne onClick={onClick} activeStep={activeStep} />;
    case 1:
      return <StepTwo onClick={onClick} activeStep={activeStep} />;
    case 2:
      return <StepThree onClick={onClick} activeStep={activeStep} />;
    case 3:
      return <StepFour onClick={onClick} activeStep={activeStep} />;
  }
};

const ScenarioPlanStepOverview = () => {
  const [activeStep, setActiveStep] = useState<number>(0);

  const handleStep = (step: number) => {
    setActiveStep(step);
  };

  return (
    <Paper transparent>
      <Box display={'flex'} flexDirection={'row'} width={'100%'}>
        <Box
          width={'20%'}
          sx={{
            '& span': {
              color: 'white',
              '& .Mui-active': {
                '&.MuiStepLabel-labelContainer': {
                  color: 'white !important',
                },
              },
            },
          }}>
          <StepsSideBar onClick={handleStep} activeStep={activeStep} />
        </Box>
        <Box width={'80%'}>
          <RenderStep activeStep={activeStep} onClick={handleStep} />
        </Box>
      </Box>
    </Paper>
  );
};

const ScenarioPlanStepContainer = () => {
  return (
    <ScenarioPlanProvider>
      <ScenarioPlanStepOverview />
    </ScenarioPlanProvider>
  );
};

export default ScenarioPlanStepContainer;
